<template>
  <action-dialog
    title="Удаление ГВС"
    :name="name"
    v-model="dialogState"
    @onAction="closeAndAction"
    @onClose="closeDialog"
    colorBtnAction="error"
    label="Вы действительно хотите удалить текущего ГВС ?"
    labelBtnClose="ОТМЕНА"
    labelBtnAction="УДАЛИТЬ"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn text title="Удалить ГВС" v-bind="attrs" v-on="on">
        <v-icon>mdi-delete-forever-outline</v-icon>
        Удалить ГВС
      </v-btn>
    </template>
  </action-dialog>
</template>

<script>
import ActionDialog from '@/components/dialogs/ActionDialog'
export default {
  name: 'GvsDeleteDialog',
  components: { ActionDialog },
  data: () => ({
    dialogState: false,
  }),

  props: {
    name: {
      type: String,
      required: false,
      default: '',
    },
  },

  methods: {
    closeDialog() {
      this.dialogState = false
      this.$emit('onClose')
    },
    closeAndAction() {
      this.dialogState = false
      this.$emit('onAction')
    },
  },
}
</script>
